import angular from 'angular';
import 'angular-jwt';
import 'angular-local-storage';
import 'angular-sanitize';
import 'angular-messages';
import 'angular-bind-notifier';
import 'ng-table';
import 'ui-select';
import 'angular-moment';
import 'angular-modal-service';
import 'angular-ckeditor';
import 'angular-recaptcha';
import 'ng-sortable';
import 'ngSticky';
import { vrmConfigModule } from '@/angular/modules/vrm-config';
import { vrmRouteModule } from '@/angular/modules/vrm.route';
import { vrmComponentsModule } from '@/angular/modules/vrm.components';
import { vrmGraphModule } from '@/angular/modules/vrm-graph';
import { vrmVueModule } from '@/angular-bridge/module';
import { vrmWhitelabelModule } from '@/angular/modules/vrm-whitelabel';
import { vrmEssGraphModule } from "@/angular/modules/vrm-ess-graph";
import { vrmApiModule } from '@/angular/modules/vrm-api';
import { vrmLocalesModule } from '@/angular/modules/vrm.locales';

export const vrmCoreModule = angular.module('vrm.core', [
    vrmConfigModule.name,
    vrmRouteModule.name,
    vrmComponentsModule.name,
    vrmGraphModule.name,
    vrmVueModule.name,
    vrmWhitelabelModule.name,
    vrmEssGraphModule.name,
    vrmApiModule.name,
    vrmLocalesModule.name,
    'angular-jwt',
    'LocalStorageModule',
    'ngMessages',
    'ngTable',
    'ui.select',
    'ngSanitize',
    'angularMoment',
    'angularModalService',
    'ckeditor',
    'as.sortable',
    'sticky',
    'vcRecaptcha',
    'angular.bind.notifier'
]);

vrmCoreModule.config([
    "uiSelectConfig",
    function (uiSelectConfig) {
        uiSelectConfig.dropdownPosition = "down";
    }
]);

// Override $state methods
vrmRouteModule.run(['$state',
    function ($state) {
        $state.originalHrefFunction = $state.href;
        $state.href = function href(stateOrName, params, options) {
            var result = $state.originalHrefFunction(stateOrName, params, options);
            // Check if result is defined and contains '#', then crop '#' and everything after
            if (result && result.indexOf("#") !== -1) {
                result = result.slice(0, result.indexOf("#"));
                // If params is defined and includes '#', then return sliced result + the anchor
                if (params && Object.keys(params).includes("#")) {
                    result += "#" + params['#']
                }
                return result;
            }
            return result;
        }
    }
])

// Import all of vrm-core
const context = require.context('./vrm-core/', true, /\.js/);

context.keys()
    .forEach(moduleDescription => {
        context(moduleDescription);
    });
